import { defineMessages } from '@jutro/locale';

export default defineMessages({
    claimDetail : {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.Claim Detail',
        defaultMessage: 'Claim Detail'
    },
    draftClaim : {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.Draft Claim',
        defaultMessage: 'Draft Claim'
    },
    closeBtn: {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.claimDetailPopup.Close',
        defaultMessage: 'Close'
    },
    popupBody: {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.claimDetailPopup.Close',
        // eslint-disable-next-line max-len
        defaultMessage: 'Umbrella claim status is unavailable through this system. Please contact our Claims Call Center at (800) 854-6011 for Umbrella claim assistance'
    }
});
